import ManualFill from './ManualFill.vue';

export default ManualFill;
